import React from 'react';
export function LegalFooter() {
  return <footer className="py-8 bg-white" data-id="element-175">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-176">
        <div className="border-t border-beige-sand pt-8 text-xs text-taupe leading-relaxed text-left md:text-center" data-id="element-177">
          <p data-id="element-178">
            Los precios están en pesos argentinos. El producto es digital. Los
            resultados dependen de tu aplicación, tu mercado y tu esfuerzo.
            Mercado Pago es responsable de las condiciones de pago y cuotas
            según su plataforma. Este sitio no es parte del sitio web de
            Facebook o Facebook Inc. Además, este sitio NO está respaldado por
            Facebook de ninguna manera. FACEBOOK es una marca registrada de
            FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}